<template>
  <div class="pad30">
    <h2 class="f18 fb normal gray_2">客户分组</h2>
    <div class="box20"></div>
    <div class="flex flex-wrap flex1 items-center mar20-b">
      <div>
        <span>分组名称：</span>
        <el-input class="w210 mar20_r" placeholder="请输入分组名称" v-model.trim="searchName"></el-input>
      </div>
      <el-button @click="searchName = ''">重置</el-button>

      <el-button type="primary" @click="getList">查询</el-button>

      <el-button type="primary" class="mar-20-l" @click="addGroup">新增分组</el-button>
    </div>
    <el-table :data="list" @selection-change="groupSelect" row-key="id" style="width: 100%">
      <el-table-column type="selection" :selectable="groupNotSelect" :reserve-selection="true" width="55"> </el-table-column>
      <el-table-column show-overflow-tooltip prop="name" label="分组名称" />
      <el-table-column prop="customerNum" label="客户数量" />
      <el-table-column label="操作" width="240">
        <template slot-scope="scope" v-if="scope.row.isDefault == 0">
          <el-button type="primary" @click="addGroup(scope.row)">编辑</el-button>
          <el-button type="primary" class="mar15-l" @click="deleteGroup(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex items-center mar20-t">
      <el-button type="primary" :disabled="this.multipleSelection.length == 0" @click="deleteGroupList">删除分组</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import requestApi from "@/utils/requestApi";

export default {
  data() {
    return {
      env: process.env,
      searchName: "",
      list: [],
      multipleSelection: [],
      thisGroup: {},
      shop: {},
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    requestApi.post(`${process.env.VUE_APP_APITAAS}sctrading/shop/mj/info`, {}).then((res) => {
      this.shop = res.data;
      this.getList();
    });
  },
  methods: {
    getList() {
      requestApi
        .post(`${process.env.VUE_APP_APITAAS}scbasic/member/customergroup/selList`, {
          name: this.searchName,
          shopId: this.shop.shopId,
        })
        .then((res) => {
          this.list = res.data;
        });
    },
    addGroup(item) {

      this.$prompt("请输入分组名称", item.id ? "编辑" : "添加", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPlaceholder: "请输入分组名称(至多15字)",
        inputValidator: (value) => {
          if (value == null || value.trim() == "") {
            return "请输入分组名称";
          }
          if (value.length > 15) {
            return "分组名称至多15个字";
          }
        },
        inputErrorMessage: "请输入分组名称",
        inputValue: item ? item.name : "",
      })
        .then(({ value }) => {
          if (item.id) {
            requestApi
              .post(`${process.env.VUE_APP_APITAAS}scbasic/member/customergroup/edit`, {
                name: value.trim(),
                id: item.id,
              })
              .then((res) => {
                if (res.code == "0") {
                  this.$message.success("编辑成功");
                  this.getList();
                } else {
                  this.$message.error(res.msg);
                }
              });
            return;
          }
          requestApi
            .post(`${process.env.VUE_APP_APITAAS}scbasic/member/customergroup/add`, {
              name: value.trim(),
            })
            .then((res) => {
              if (res.code == "0") {
                this.$message.success("添加成功");
                this.getList();
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => {});
    },
    groupSelect(val) {
      this.multipleSelection = val || [];
      console.log(this.multipleSelection);
    },
    groupNotSelect(row) {
      if (row.isDefault == 1) {
        return false;
      }
      return true;
    },
    deleteGroup(id) {
      const idList = [id];
      this.$confirm("您是要删除当前所选客户分组吗?", "提示").then(() => {
        requestApi
          .post(`${process.env.VUE_APP_APITAAS}scbasic/member/customergroup/del`, {
            idList: idList,
          })
          .then((res) => {
            if (res.code == "0") {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
      });
    },

    deleteGroupList() {
      if (this.multipleSelection.length == 0) {
        this.$message.info("请选择分组");
        return;
      }
      const idList = [];
      this.multipleSelection.forEach(function (item) {
        idList.push(item.id);
      });
      this.$confirm("您是要删除当前所选客户分组吗?", "提示").then(() => {
        requestApi
          .post(`${process.env.VUE_APP_APITAAS}scbasic/member/customergroup/del`, {
            idList: idList,
          })
          .then((res) => {
            if (res.code == "0") {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index.scss";
</style>
<style>
.el-select-dropdown__item.selected {
  color: #0095f1;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #0095f1;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #0095f1;
  border-color: #0095f1;
}
.el-checkbox__input.is-focus .el-checkbox__inner,
.el-checkbox__inner:hover {
  border-color: #0095f1;
}
.el-input-group__prepend .el-select {
  width: 75px;
}
.el-tabs__item.is-active {
  color: #0095f1;
}
.el-tabs__item:hover {
  color: #0095f1;
}
.el-tabs__active-bar {
  background-color: #0095f1;
}
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #0095f1;
  border-color: #0095f1;
}
.el-input__inner:focus {
  outline: none;
  border-color: #57aaff;
}

.el-button--primary:hover,
.el-button--primary:focus {
  background: #0095f1;
  border-color: #0095f1;
  color: #ffffff;
}

.el-button--primary:active {
  background: #0095f1;
  border-color: #0095f1;
  color: #ffffff;
  outline: none;
}
.el-button--primary {
  color: #ffffff;
  background-color: #0095f1;
  border-color: #0095f1;
}
.el-button:active {
  color: #ffffff;
  outline: none;
}

.el-message-box .el-button:active {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-message-box .el-button:hover,
.el-message-box .el-button:focus {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}

.el-button--primary.is-disabled,
.el-button--primary.is-disabled:hover,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:active {
  color: #ffffff;
  border-color: #0095f1;
  background-color: #0095f1;
}
</style>
